import type { CSSProperties } from 'react';
import { useMemo } from 'react';

import classNames from 'classnames';

import SimpleModal from '@/ui/SimpleModal';

import { contentGatePopupContentContainer, contentGatePopupDialogContent } from './ContentGatePopup.css';
import type { ContentGatePopupElementProps } from './ContentGatePopup.types';

export function ContentGatePopupElement(props: ContentGatePopupElementProps) {
  const { children, element, isOpen = false, isPreviewing = false, onOpenChange, attributes, previewViewport } = props;

  const {
    width,
    maxWidth,
    gap,
    backgroundColor,
    borderRadius,
    borderWidth,
    borderColor,
    borderStyle,
    modalOverlayBackgroundColor,
    position,
    hasGradientBackground = false,
  } = element.attrs || {};

  const generatedStyle = {
    '--overlay-background-color': modalOverlayBackgroundColor,
  } as CSSProperties;

  const positionClassName = useMemo(() => {
    switch (position) {
      case 'bottom':
        return 'items-end';
      case 'top':
        return 'items-start';
      case 'center':
        return 'items-center';
      default:
        return '';
    }
  }, [position]);

  const renderedElement = (
    <div
      className={classNames(
        contentGatePopupContentContainer,
        'flex flex-col h-auto relative',
        hasGradientBackground && 'bg-gradient-to-t from-[var(--content-background-color)] from-80%',
      )}
      style={
        {
          '--width': width,
          '--max-width': maxWidth,
          '--content-background-color': backgroundColor,
          backgroundColor: !hasGradientBackground ? 'var(--content-background-color)' : undefined,
          borderStyle,
          borderWidth,
          borderRadius,
          borderColor,
          gap,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );

  if (isPreviewing) {
    return (
      <div
        className={classNames(
          'w-full h-full flex justify-center relative',
          previewViewport === 'mobile' ? 'items-end' : positionClassName,
        )}
        style={generatedStyle}
        {...attributes}
      >
        <div className="absolute top-0 left-0 w-full h-full bg-[--overlay-background-color]">&nbsp;</div>
        <div
          className="z-10 relative"
          style={
            {
              width,
              maxWidth,
            } as CSSProperties
          }
        >
          {/* <BlurGradient color={backgroundColor} /> */}
          {renderedElement}
        </div>
      </div>
    );
  }

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onOpenChange}
      style={generatedStyle}
      showCloseButton={false}
      showRoundedBorders={false}
      placement={position}
      shouldCloseOnOutsideClick={false}
      shouldDisableScroll={false}
    >
      <div className={classNames(contentGatePopupDialogContent, 'relative')} {...attributes}>
        {/* <BlurGradient color={backgroundColor} /> */}
        {renderedElement}
      </div>
    </SimpleModal>
  );
}
